import { useState } from "react";
import { useAppActions } from "../../overmind";
import { onConnect } from "../../core/web3";

const NavBar = ({ wallet, setWallet }) => {
  const { toggleMenu } = useAppActions();

  const onConnect1 = async () => {
    let res = await onConnect();
    setWallet(res.address != "");
  };

  return (
    <nav className="h-14 my-auto px-4 md:px-8 xl:px-12 fixed top-0 w-full bg-gray-800">
      <div className="x-between h-full">
        <div className="h-full my-auto y-center">
          <img
            src="/metasino.svg"
            className="h-4 sm:h-5 my-auto"
            alt="metasino logo"
          />
        </div>

        <button onClick={() => toggleMenu(true)} className="flex align-middle">
          {wallet ? (
            <div className="y-center my-auto">
              <div className="rounded-full bg-green-500 bg-opacity-20 px-2.5 py-1 flex align-middle">
                <div className="rounded-full bg-green-500 mr-2 h-2 w-2 my-auto"></div>
                <div className="text-green-500 font-secondary font-medium uppercase text-sm">
                  wallet connected
                </div>
              </div>
            </div>
          ) : (
            <div className="y-center my-auto" onClick={onConnect1}>
              <div className="rounded-full bg-red-500 bg-opacity-20 px-2.5 py-1 flex align-middle">
                <div className="rounded-full bg-red-500 mr-2 h-2 w-2 my-auto"></div>
                <div className="text-red-500 font-secondary font-medium uppercase text-sm">
                  Connect Wallet
                </div>
              </div>
            </div>
          )}

          <div className="p-3 text-white -mr-3 my-auto">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <line x1="3" y1="12" x2="21" y2="12"></line>
              <line x1="3" y1="6" x2="21" y2="6"></line>
              <line x1="3" y1="18" x2="21" y2="18"></line>
            </svg>
          </div>
        </button>
      </div>
    </nav>
  );
};

export default NavBar;
